const { createHooks } = require('./createHooks')

const createFedopsOptions = appLogger => {
  const { startHook, endHook } = createHooks(appLogger)
  const fedopsLoggerOptions = {
    interactionTimeout: 50000,
    startHook,
    endHook
  }

  return fedopsLoggerOptions
}

module.exports = createFedopsOptions
